<nav class="navbar navbar-expand-lg">
  <img src="../assets/img/wormreading.png" title="Designed by pch.vector / freepik" width="5%" height="5%">
  <a class="navbar-brand" routerLink="/home">BookWorm SE</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" routerLink="/home" routerLinkActive="active">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/search" routerLinkActive="active">Advanced search</a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Contact us
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" href="https://www.linkedin.com/in/chachir/">Nadia Carrera Chahir</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="https://www.linkedin.com/in/alejandro-leiva-palomo-5a6a62185/">Alejandro Leiva
            Palomo</a>
        </div>
      </li>
    </ul>
  </div>
</nav>
